import React from "react";

interface BranchData {
  id: number;
  name: string;
  chilitosOperacion: {
    matutinos: { actuales: number; requeridos: number };
    intermedios: { actuales: number; requeridos: number };
    vespertinos: { actuales: number; requeridos: number };
  };
  puestosCubiertos: {
    matutinos: { cubiertos: number; total: number };
    intermedios: { cubiertos: number; total: number };
    vespertinos: { cubiertos: number; total: number };
  };
  faltasDia: number;
  coberturaFaltas: {
    cubiertas: number;
    total: number;
    porcentaje: number;
  };
  chilitosDobleFuncion: number;
  details: {
    operacionList: any[];
    faltantesList: any[];
    proximosList: any[];
    puestosList: any[];
    coberturaList: any[];
    dobleFuncionList: any[];
  };
}

const RiesgoOperativoRow = ({
  item,
  no,
  onShowDetails,
}: {
  item: BranchData;
  no: number;
  onShowDetails: (branch: BranchData, type: string) => void;
}) => {
  const totalChilitosActuales =
    item.chilitosOperacion.matutinos.actuales +
    item.chilitosOperacion.intermedios.actuales +
    item.chilitosOperacion.vespertinos.actuales;

  const totalChilitosRequeridos =
    item.chilitosOperacion.matutinos.requeridos +
    item.chilitosOperacion.intermedios.requeridos +
    item.chilitosOperacion.vespertinos.requeridos;

  const totalPuestosCubiertos =
    item.puestosCubiertos.matutinos.cubiertos +
    item.puestosCubiertos.intermedios.cubiertos +
    item.puestosCubiertos.vespertinos.cubiertos;

  const totalPuestos =
    item.puestosCubiertos.matutinos.total +
    item.puestosCubiertos.intermedios.total +
    item.puestosCubiertos.vespertinos.total;

  const porcentajePuestos =
    totalPuestos > 0
      ? Math.round((totalPuestosCubiertos / totalPuestos) * 100)
      : 0;

  const getChilitosColor = () => {
    const porcentaje =
      totalChilitosRequeridos > 0
        ? (totalChilitosActuales / totalChilitosRequeridos) * 100
        : 100;
    if (porcentaje >= 100) return "#28a745";
    if (porcentaje >= 80) return "#ff9800";
    return "#dc3545";
  };

  const getShiftColor = (actual: number, required: number) => {
    if (required <= 0) return "#6c757d";
    const porcentaje = (actual / required) * 100;
    if (porcentaje >= 100) return "#28a745";
    if (porcentaje >= 80) return "#ff9800";
    return "#dc3545";
  };

  const getPuestosColor = () => {
    if (porcentajePuestos >= 90) return "#28a745";
    if (porcentajePuestos >= 70) return "#ff9800";
    return "#dc3545";
  };

  const getPuestosShiftColor = (covered: number, total: number) => {
    if (total <= 0) return "#6c757d";
    const porcentaje = (covered / total) * 100;
    if (porcentaje >= 100) return "#28a745";
    if (porcentaje >= 80) return "#ff9800";
    return "#dc3545";
  };

  const getFaltasColor = () => {
    if (item.faltasDia === 0) return "#28a745";
    if (item.faltasDia <= 2) return "#ff9800";
    return "#dc3545";
  };

  const getCoberturaColor = () => {
    if (item.coberturaFaltas.porcentaje === 100) return "#28a745";
    if (item.coberturaFaltas.porcentaje >= 50) return "#ff9800";
    return "#dc3545";
  };

  const getRowBackgroundColor = () => {
    return no % 2 === 0 ? "#f8f9fa" : "white";
  };

  return (
    <tr
      style={{
        backgroundColor: getRowBackgroundColor(),
        borderBottom: "1px solid #dee2e6",
        height: "46px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#e9ecef";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = getRowBackgroundColor();
      }}
    >
      <td
        style={{
          padding: "8px",
          borderRight: "1px solid #dee2e6",
          fontWeight: "600",
          color: "#212529",
        }}
        className="text-center"
      >
        <div>
          <span style={{ fontSize: "13px", fontWeight: "600" }}>{item.name}</span>
        </div>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getShiftColor(
              item.chilitosOperacion.matutinos.actuales,
              item.chilitosOperacion.matutinos.requeridos
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.chilitosOperacion.matutinos.actuales}/
          {item.chilitosOperacion.matutinos.requeridos}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getShiftColor(
              item.chilitosOperacion.intermedios.actuales,
              item.chilitosOperacion.intermedios.requeridos
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.chilitosOperacion.intermedios.actuales}/
          {item.chilitosOperacion.intermedios.requeridos}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getShiftColor(
              item.chilitosOperacion.vespertinos.actuales,
              item.chilitosOperacion.vespertinos.requeridos
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.chilitosOperacion.vespertinos.actuales}/
          {item.chilitosOperacion.vespertinos.requeridos}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          onClick={() => onShowDetails(item, "operacion")}
          style={{
            backgroundColor: getChilitosColor(),
            color: "white",
            padding: "5px 10px",
            borderRadius: "10px",
            fontSize: "11px",
            fontWeight: "700",
            display: "inline-block",
            cursor: "pointer",
            minWidth: "60px",
          }}
        >
          {totalChilitosActuales}/{totalChilitosRequeridos}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getPuestosShiftColor(
              item.puestosCubiertos.matutinos.cubiertos,
              item.puestosCubiertos.matutinos.total
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.puestosCubiertos.matutinos.cubiertos}/
          {item.puestosCubiertos.matutinos.total}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getPuestosShiftColor(
              item.puestosCubiertos.intermedios.cubiertos,
              item.puestosCubiertos.intermedios.total
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.puestosCubiertos.intermedios.cubiertos}/
          {item.puestosCubiertos.intermedios.total}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          style={{
            color: getPuestosShiftColor(
              item.puestosCubiertos.vespertinos.cubiertos,
              item.puestosCubiertos.vespertinos.total
            ),
            fontSize: "11px",
            fontWeight: "600",
            display: "inline-block",
            minWidth: "50px",
          }}
        >
          {item.puestosCubiertos.vespertinos.cubiertos}/
          {item.puestosCubiertos.vespertinos.total}
        </span>
      </td>
      <td
        style={{
          padding: "8px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          onClick={() => onShowDetails(item, "puestos")}
          style={{
            backgroundColor: getPuestosColor(),
            color: "white",
            padding: "5px 10px",
            borderRadius: "10px",
            fontSize: "11px",
            fontWeight: "700",
            display: "inline-block",
            cursor: "pointer",
            minWidth: "60px",
          }}
        >
          {totalPuestosCubiertos}/{totalPuestos} ({porcentajePuestos}%)
        </span>
      </td>
      <td
        style={{
          padding: "12px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          onClick={() => onShowDetails(item, "faltas")}
          style={{
            backgroundColor: getFaltasColor(),
            color: "white",
            padding: "6px 16px",
            borderRadius: "16px",
            fontSize: "16px",
            fontWeight: "700",
            display: "inline-block",
            cursor: "pointer",
          }}
        >
          {item.faltasDia}
        </span>
      </td>
      <td
        style={{
          padding: "12px",
          textAlign: "center",
          borderRight: "1px solid #dee2e6",
        }}
      >
        <span
          onClick={() => onShowDetails(item, "cobertura")}
          style={{
            backgroundColor: getCoberturaColor(),
            color: "white",
            padding: "6px 16px",
            borderRadius: "16px",
            fontSize: "14px",
            fontWeight: "600",
            display: "inline-block",
            cursor: "pointer",
          }}
        >
          {item.coberturaFaltas.cubiertas}/{item.coberturaFaltas.total} (
          {item.coberturaFaltas.porcentaje}%)
        </span>
      </td>
      <td
        style={{
          padding: "12px",
          textAlign: "center",
        }}
      >
        <span
          onClick={() => onShowDetails(item, "doble")}
          style={{
            backgroundColor: "#ff9800",
            color: "white",
            padding: "6px 16px",
            borderRadius: "16px",
            fontSize: "16px",
            fontWeight: "700",
            display: "inline-block",
            cursor: "pointer",
          }}
        >
          {item.chilitosDobleFuncion}
        </span>
      </td>
    </tr>
  );
};

export default RiesgoOperativoRow;
